import { DEFAULT_LOAN_TABS } from '../../../Blotters/OTC/Loans/defaults';
import type { LoanTabProps } from '../../../Blotters/OTC/Loans/Loans';
import { MobileBlotterPanel, type MobileBlotterPanelProps } from './MobileBlotterPanel';

/** Placeholder-only mobile loans content; uses `TradingPlaceholder` via `MobileBlotterPanel`. */
export function MobileLoansBlotter(props: Omit<MobileBlotterPanelProps<LoanTabProps>, 'defaultTabs'>) {
  return <MobileBlotterPanel<LoanTabProps> {...props} defaultTabs={DEFAULT_LOAN_TABS} />;
}
